import {
  Description,
  Field,
  Input as HeadlessUiInput,
  Label,
} from "@headlessui/react"
import { twMerge } from "tailwind-merge"

interface Props {
  autoFocus?: boolean
  description?: React.ReactNode | string
  disabled?: boolean
  invalid?: boolean
  label?: string
  name?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  type?: string
  value?: string
}

export default function Input({
  autoFocus = false,
  description,
  disabled = false,
  invalid = false,
  label,
  name,
  onChange,
  placeholder = "",
  type = "text",
  value,
}: Props) {
  return (
    <Field className="space-y-4 text-white">
      {label && (
        <Label className={twMerge("mx-7", invalid && "text-custom-error")}>
          {label}
        </Label>
      )}

      <HeadlessUiInput
        autoFocus={autoFocus}
        className="theme-input"
        disabled={disabled}
        invalid={invalid}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        value={value}
      />

      {description && (
        <Description
          className={twMerge(
            "mx-7 text-center text-xs",
            invalid && "text-custom-error",
          )}
        >
          {description}
        </Description>
      )}
    </Field>
  )
}
